import fileDefault from "../../media/file-blank-solid-240.png";
import fileCSS from "../../media/file-css-solid-240.png";
import filePdf from "../../media/file-pdf-solid-240.png";
import filePng from "../../media/file-png-solid-240.png";

export const ImageConfig = {
  default: fileDefault,
  pdf: filePdf,
  png: filePng,
  css: fileCSS,
};
